<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="customCompanyName"
    item-value="companyCd"
    :label="labelComputed"
    :disabled="disabled"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'CompanyInput',

  mixins: [APIUtils, Message],

  components: {
    SelectSingleInput,
  },

  props: {
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0002')
      },
    },
    companyCatCd: {
      type: String,
      required: false,
      default: '',
    },
    // insp_cat
    companyType: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      items: [],
      selectedItem: {},
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.company = value
        this.$emit('input', value ? value : '')
      },
    },
    labelComputed: {
      get() {
        return this.label
      },
    },
    company: {
      get() {
        return this.selectedItem
      },
      set(value) {
        this.selectedItem = this.items.find((item) => item.companyCd == value)
      },
    },
  },

  async mounted() {
    this.loading = true
    try {
      const params = {}
      if (this.companyType) {
        params.inspCat = this.companyType
      }
      if (this.companyCatCd) {
        params.companyCatCd = this.companyCatCd
      }
      if (this.validOnly) {
        params.validOnly = true
      }
      this.items = []

      const elements = await API.get('/master/companies', params)
      elements.forEach((element) => {
        element['customCompanyName'] = element['companyCd'] + ' : ' + element['companyName']
        this.items.push(element)
      })
    } catch (error) {
      this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0005') })))
    } finally {
      this.loading = false
    }
  },
}
</script>
